import { render } from "./UserList.vue?vue&type=template&id=d40f8106"
import script from "./UserList.vue?vue&type=script&lang=js"
export * from "./UserList.vue?vue&type=script&lang=js"

import "./UserList.vue?vue&type=style&index=0&id=d40f8106&lang=css"

import exportComponent from "D:\\Projects\\SPNM\\Core\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__